import React from 'react';
import Checklist from './Checklist';

const AtAGlance = () => (
  <div className="section is-medium">
    <div className="container">
      <div className="columns is-centered">
        <div className="column is-3">
          <h3 className="title is-4 has-text-centered has-text-left-mobile">Our Mission</h3>
          <p>
            To expand our position as a supplier of machined hardware and Glass
            to Metal Seals and to exceed our customers' expectations by
            supplying them with quality hardware on time and competitively
            priced and help them become successful and profitable by being a
            part of their solution in today's market place.
          </p>
        </div>
        <div className="column is-3 is-offset-1">
          <h3 className="title is-4 has-text-centered has-text-left-mobile">Our Guarantee</h3>
          <p>
            When you choose Accratronics for your parts manufacturing needs,
            you're choosing the best guarantee of perfect quality that the
            industry has to offer.
          </p>
        </div>
        <div className="column is-3 is-offset-1 has-text-centered has-text-left-mobile">
          <h3 className="title is-4">Our Services</h3>
          <Checklist
            items={ourServices}
          />
        </div>
      </div>
    </div>
  </div>
);

const ourServices = [
  { name: 'Material Sourcing', key: 1 },
  { name: 'CNC Machining', key: 2 },
  { name: 'Part Assembly', key: 3 },
  { name: 'Hermetic Glass Sealing', key: 4 },
  { name: 'Tooling Engineering', key: 5 },
  { name: 'QA & Inspection', key: 6 },
  { name: 'Non-Destructive Testing', key: 7 },
  { name: 'Delivery', key: 8 }
];

export default AtAGlance;



// WEBPACK FOOTER //
// ./src/pages/About/components/AtAGlance.js